








































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { DocumentFullTextService } from '@/services/DocumentFullTextService';
import { DocumentFullTextDataModel, DocumentFullTextModel } from '@/types';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreFilter from '@/components/shared/MStoreFilter.vue';
import { WorkflowJobModel } from '@/types';
import { BTableHelpers } from '@/mixins/bTable';

export default Vue.extend({
  name: 'WorkflowFullTextTab',
  data() {
    return {
      documentFullTextData: {} as DocumentFullTextDataModel,
      emptytext: 'No Records to show',
      isLoading: false,
      isLoadingPageText: false,
      fullTextSearch: '',
      fullTextSelected: null,
      fullText: ''
    };
  },
  mixins: [BTableHelpers],
  props: {
    workflowJobModel: {
      type: Object as () => WorkflowJobModel,
      required: true
    },
    isWorkflowJobLocked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions('documentViewStore', ['loadPage']),
    resetToInitialView(this: any) {
      this.fullText = '';
      this.$refs.fullTextTable.clearSelected();
      this.fullTextSelected = null;
      this.loadPage(1);
    },
    async onRefreshClicked(this: any) {
      await this.getWorkflowFullTextAsync();
    },
    async getWorkflowFullTextAsync(this: any) {
      this.resetToInitialView();
      this.fullTextSearch = '';
      this.isLoading = true;
      try {
        const result = (await DocumentFullTextService.getAllFullTextAsync(this.documentSearchModel.cabinetId, this.documentSearchModel.documentId)) as DocumentFullTextDataModel;

        this.documentFullTextData = result;
      } catch (error) {
        this.$log(error);
        this.documentFullTextData = {};
      } finally {
        this.isLoading = false;
      }
    },
    async onSearchClicked(this: any) {
      await this.searchAllFullTextAsync();
    },
    async searchAllFullTextAsync(this: any) {
      this.resetToInitialView();
      this.isLoading = true;
      try {
        const result = (await DocumentFullTextService.searchAllFullTextAsync(
          this.documentSearchModel.cabinetId,
          this.documentSearchModel.documentId,
          this.fullTextSearch
        )) as DocumentFullTextDataModel;

        this.documentFullTextData = result;
      } catch (error) {
        this.$log(error);
      } finally {
        this.isLoading = false;
      }
    },
    async onRowSelected(this: any, items: DocumentFullTextModel[]) {
      if (items.length === 0) {
        return;
      }
      this.fullTextSelected = items[0];
      this.loadPage(this.fullTextSelected.page);
      this.fullText = '';
      this.isLoadingPageText = true;
      try {
        const result = (await DocumentFullTextService.getFullTextAsync(this.documentSearchModel.cabinetId, this.documentSearchModel.documentId, this.fullTextSelected.uniqueId)) as string;

        if (!this.isLoading) {
          this.fullText = result;
        }
      } catch (error) {
        this.$log(error);
        this.resetToInitialView();
      } finally {
        this.isLoadingPageText = false;
      }
    },
    async onCopyToClipboard(this: any) {
      await navigator.clipboard.writeText(this.fullText);
    },
    onEnterSearch(this: any, event: any) {
      if (event.key === 'Enter') {
        this.searchAllFullTextAsync();
      }
    }
  },
  computed: {
    ...mapGetters('documentViewStore', ['documentSearchModel']),
    fullTextSearchEmpty(this: any) {
      return !this.fullTextSearch || this.fullTextSearch.length === 0;
    },
    showFullPageTextPlaceholder(this: any) {
      return !this.fullTextSelected && !this.isLoadingPageText;
    },
    anyLoading(this: any) {
      return this.isLoading || this.isLoadingPageText;
    }
  },
  watch: {
    fullTextSearchEmpty(this: any, value: string) {
      if (value && this.documentFullTextData.fullTextSearch) {
        this.getWorkflowFullTextAsync();
      }
    }
  },
  mounted() {
    this.getWorkflowFullTextAsync();
  },
  components: {
    LoadingSpinner,
    MStoreFilter
  }
});
